import styled from "styled-components";
import { useEffect, useState, lazy } from "react";
import { mobile } from "../responsive";
import { useLocation, useHistory, Link } from "react-router-dom";
import { categories, descriptors } from "../data";
import TuneIcon from "@mui/icons-material/Tune";
const Navbar = lazy(() => import("../Components/Navbar"));
const Products = lazy(() => import("../Components/Products"));
const Footer = lazy(() => import("../Components/Footer"));
const SEO = lazy(() => import("../Components/SEO"));
const SubCatSEO = lazy(() =>
  import("../Components/SubCatLandingPages/SubCatSEO")
);

const Container = styled.div``;

const Title = styled.h1`
  margin: 20px;
`;
const Desc = styled.h2`
  margin: 0 10px 10px 20px;
  font-size: 1.2em;
  font-weight: 400;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  ${mobile({ flexDirection: "column" })}
`;

const Filter = styled.div`
  margin: 20px;
  ${mobile({
    width: "0px 20px",
    margin: "0px 10px",
    display: "flex",
    flexDirection: "column",
  })}
`;

const DisplayFilters = styled.div`
  display: ${(props) => (props.hidden === false ? "inline-flex" : "none")};
  ${mobile({
    display: (props) => {
      return props.hidden === false ? "flex" : "none";
    },
    flexDirection: "column",
  })};
`;

const Select = styled.select`
  padding: 10px;
  margin-right: 20px;
  -webkit-appearance: none;
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  ${mobile({ margin: "10px 0px" })}
`;

const Nav = styled.nav`
  margin: 0.5em 0 0 20px;
`;

const CrumbsOl = styled.ol`
  list-style-type: none;
  padding-left: 0;
`;

const Crumb = styled.li`
  display: inline-block;
  text-overflow: elipsis;
  a::after {
    display: inline-block;
    color: #767676;
    content: ">";
    font-size: 80%;
    font-weight: bold;
    padding: 0 3px;
  }
`;

const ProductList = () => {
  const location = useLocation();
  const cat = location.pathname.split("/")[2];
  const paramSub = location.pathname.split("/")[3];
  const [filters, setFilters] = useState({});
  const [sort, setSort] = useState("");
  const [sidebar, setSidebar] = useState({ isHidden: true });
  const history = useHistory();

  useEffect(() => {
    setFilters({
      ...filters,
      subcat: encodeURIComponent(paramSub),
    });
  }, [paramSub]);

  const subCategory = (category) => {
    const cats = categories.filter((element) => {
      return element.cat === category;
    });

    const subcat = cats[0]?.subcat;
    if (subcat) {
      return subcat.map((element, i) => {
        return (
          <option value={element} key={i}>
            {element}
          </option>
        );
      });
    }
  };

  var catTitle = categories.find((element) => element.cat === cat)?.title;
  if (paramSub) {
    catTitle = descriptors.filter((element) => {
      if (decodeURIComponent(paramSub) == element.subCat) {
        return element;
      }
    });
    catTitle = catTitle[0]?.headline;
  }
  const catDesc = categories.find((element) => element.cat === cat)?.desc;
  const htmlTitle = `Rent ${
    paramSub ? decodeURIComponent(paramSub) : catTitle
  } | Rentoodle`;
  const toggleHidden = () => {
    setSidebar({ isHidden: !sidebar.isHidden });
  };

  const handleFilters = (e) => {
    const value = e.target.value;
    e.target.value === ""
      ? history.go(0)
      : setFilters({
          ...filters,
          [e.target.name]: value,
        });
  };

  const handleSort = (e) => {
    const value = e.target.value;

    // Check if the selected value is an empty string
    if (value === "") {
      // Reset the sort state to an empty object
      setSort({});
    } else {
      // Update the sort state with the selected value
      setSort({
        [e.target.name]: value,
      });
    }
  };

  const categoryBanner = [
    "Womens Fashion",
    "Home and Kitchen",
    "Baby Equipment and Clothes",
    "Tools and DIY",
    "Video Games and Consoles",
    "Rent Office Equipment",
    "Pet Supplies",
    "Musical Instruments and DJ",
    "Lighting",
    "Garden Tools",
    "Appliances",
    "DVD and Blu-ray",
    "Computers and Accessories",
    "CDs and Vinyls",
    "Industrial Equipment",
    "Sports and Outdoors",
    "Luggage & Travel Gear",
    "Novelty Fashion",
    "Jewellery and Watches",
    "Mens Fashion",
    "Toys and Games",
    "Electronics and Photo",
    "Office Supplies",
  ];

  const subCatBanner = ["Cameras", "Designer Dresses", "Designer Handbags"];

  return (
    <>
      <SEO
        title={htmlTitle}
        description={`Find and rent ${htmlTitle} and other items on Rentoodle.com. Rentoodle is an advertising platform for renting and lending things.`}
      />
      <Container>
        <Navbar />
        <Nav>
          <CrumbsOl>
            <Crumb>
              <Link to="/" style={{ textDecoration: "none", color: "#747474" }}>
                Home
              </Link>
            </Crumb>
            <Crumb>{catTitle}</Crumb>
          </CrumbsOl>
        </Nav>
        {subCatBanner.includes(paramSub) ? (
          <SubCatSEO item={paramSub} />
        ) : categoryBanner.includes(catTitle) ? (
          <SubCatSEO item={catTitle} />
        ) : (
          <>
            <Title>Rent {catTitle}</Title>
            <Desc>{catDesc}</Desc>
          </>
        )}
        <FilterContainer>
          {cat === ("womens-fashion" || "mens-fashion") && (
            <>
              <Filter>
                <TuneIcon
                  fontSize="large"
                  onClick={toggleHidden}
                  sx={{
                    cursor: "pointer",
                    color: sidebar.isHidden ? "black" : "#4339fa",
                  }}
                />
              </Filter>

              <DisplayFilters hidden={sidebar.isHidden}>
                <Filter>
                  <Select name="subcat" onChange={handleFilters} tabindex="-1">
                    <option value="blank">All subcategories</option>
                    {subCategory(cat)}
                  </Select>
                </Filter>
                <Filter>
                  <Select name="colour" onChange={handleFilters} tabindex="-1">
                    <option value="">Select a colour</option>
                    <option value="Beige">Beige</option>
                    <option value="Black">Black</option>
                    <option value="Blue">Blue</option>
                    <option value="Brown">Brown</option>
                    <option value="Copper">Copper</option>
                    <option value="Cream">Cream</option>
                    <option value="Gold">Gold</option>
                    <option value="Green">Green</option>
                    <option value="Grey">Grey</option>
                    <option value="Multi">Multi</option>
                    <option value="Navy">Navy</option>
                    <option value="Orange">Orange</option>
                    <option value="Pink">Pink</option>
                    <option value="Purple">Purple</option>
                    <option value="Red">Red</option>
                    <option value="Silver">Silver</option>
                    <option value="Tan">Tan</option>
                    <option value="White">White</option>
                    <option value="Yellow">Yellow</option>
                    <option value="Translucent">Translucent</option>
                  </Select>
                </Filter>
                <Filter>
                  <Select name="size" onChange={handleFilters} tabindex="-1">
                    <option value="">Select a size</option>
                    <option value="One Size">One Size</option>
                    <option value="UK 4/EU 32">UK 4 / EU 32</option>
                    <option value="UK 5/EU 33">UK 5 / EU 33</option>
                    <option value="UK 6/EU 34">UK 6 / EU 34</option>
                    <option value="UK 7/EU 35">UK 7 / EU 35</option>
                    <option value="UK 8/EU 36">UK 8 / EU 36</option>
                    <option value="UK 9/EU 37">UK 9 / EU 37</option>
                    <option value="UK 10/EU 38">UK 10/EU 38</option>
                    <option value="UK 11/EU 39">UK 11/EU 39</option>
                    <option value="UK 12/EU 40">UK 12/EU 40</option>
                    <option value="UK 13/EU 41">UK 13/EU 41</option>
                    <option value="UK 14/EU 42">UK 14/EU 42</option>
                    <option value="UK 15/EU 43">UK 15/EU 43</option>
                    <option value="UK 16/EU 44">UK 16/EU 44</option>
                    <option value="UK 17/EU 45">UK 17/EU 45</option>
                    <option value="UK 18/EU 46">UK 18/EU 46</option>
                    <option value="UK 19/EU 47">UK 19/EU 47</option>
                    <option value="UK 20/EU 48">UK 20/EU 48</option>
                    <option value="UK 21/EU 49">UK 21/EU 49</option>
                    <option value="UK 22/EU 50">UK 22/EU 50</option>
                    <option value="UK 23/EU 51">UK 23/EU 51</option>
                    <option value="UK 24/EU 52">UK 24/EU 52</option>
                    <option value="UK 25/EU 53">UK 25/EU 53</option>
                    <option value="UK 26/EU 54">UK 26/EU 54</option>
                    <option value="UK 27/EU 55">UK 27/EU 55</option>
                    <option value="UK 28/EU 56">UK 28/EU 56</option>
                    <option value="UK 29/EU 57">UK 29/EU 57</option>
                    <option value="UK 30/EU 58">UK 30/EU 58</option>
                    <option value="UK 31/EU 59">UK 31/EU 59</option>
                    <option value="UK 32/EU 60">UK 32/EU 60</option>
                  </Select>
                </Filter>
              </DisplayFilters>
            </>
          )}
          <Filter>
            <Select
              name="sort"
              onChange={handleSort}
              value={sort.sort || ""}
              tabindex="-1"
            >
              <option value="">Sort by</option>
              <option value="asc">Price Low - High</option>
              <option value="desc">Price High - Low</option>
            </Select>
          </Filter>
        </FilterContainer>
        <Products cat={cat} filters={filters} sort={sort} />

        <Footer />
      </Container>
    </>
  );
};

export default ProductList;
